(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["de-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-de-unit]');
    if (!button) return;
    const guide = button.closest('.de-size-guide');
    const wrapper = guide?.querySelector('[data-de-native-unit]');
    if (!wrapper) return;
    const targetUnit = button.dataset.deUnit;
    const sourceUnit = wrapper.dataset.deNativeUnit;
    wrapper.querySelectorAll('tbody tr').forEach((row) => {
      Array.from(row.cells).slice(1).forEach((cell) => {
        const value = cell.dataset.deOriginalMeasurement ?? cell.textContent.trim();
        const number = Number(value);
        if (!Number.isFinite(number)) return;
        cell.dataset.deOriginalMeasurement = value;
        const converted = sourceUnit === targetUnit ? number : sourceUnit === 'in' ? number * 2.54 : number / 2.54;
        cell.textContent = sourceUnit === targetUnit ? value : String(Math.round(converted * 100) / 100);
      });
    });
    wrapper.querySelectorAll('th').forEach((cell) => {
      cell.textContent = cell.textContent.replace(/\((cm|in)\)/g, `(${targetUnit})`);
    });
    guide.querySelectorAll('[data-de-unit]').forEach((unitButton) => unitButton.setAttribute('aria-pressed', String(unitButton === button)));
  });
  } catch(e) { console.error(e); }
})();

})();
